(function () {
  var styleId = 'cl-footer-shopify-forms-shadow-style';
  var styles = [
    ':host {',
    '  --container-text-alignment: left !important;',
    '  --inline-form-alignment: flex-start !important;',
    '}',
    'h2 {',
    '  width: 100% !important;',
    '  margin-bottom: 20px !important;',
    '  margin-left: 0 !important;',
    '  margin-right: 0 !important;',
    '  text-align: left !important;',
    '  font-size: 25px !important;',
    '  font-weight: 700 !important;',
    '}',
    "[class*='_formHeader_'] {",
    '  width: 100% !important;',
    '  margin-bottom: 15px !important;',
    '  align-items: flex-start !important;',
    '  justify-content: flex-start !important;',
    '  text-align: left !important;',
    '}',
    "input[data-testid^='field-'] {",
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  box-sizing: border-box !important;',
    '  padding-left: 24px !important;',
    '  font-weight: 700 !important;',
    '}',
    'label[for] {',
    '  left: 24px !important;',
    '}',
    "button[data-testid='btn-form-submit'] {",
    '  display: flex !important;',
    '  width: 70% !important;',
    '  align-items: center !important;',
    '  justify-content: space-between !important;',
    '  box-sizing: border-box !important;',
    '  text-align: left !important;',
    '  font-size: 18px !important;',
    '  font-weight: 700 !important;',
    '  padding-left: 24px !important;',
    '  padding-right: 28px !important;',
    '}',
    "button[data-testid='btn-form-submit']::after {",
    "  content: '';",
    '  display: block;',
    '  width: 28px;',
    '  height: 20px;',
    '  margin-left: auto;',
    '  background-color: currentColor;',
    '  -webkit-mask: url("data:image/svg+xml,%3Csvg width=\'35\' height=\'24\' viewBox=\'0 0 35 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M21.9 1.6L32.3 12L21.9 22.4M32.3 12H2\' stroke=\'black\' stroke-width=\'4\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center / contain no-repeat;',
    '  mask: url("data:image/svg+xml,%3Csvg width=\'35\' height=\'24\' viewBox=\'0 0 35 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M21.9 1.6L32.3 12L21.9 22.4M32.3 12H2\' stroke=\'black\' stroke-width=\'4\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center / contain no-repeat;',
    '}',
    "[class*='_inline_'],",
    "[class*='_container_'],",
    "[class*='_formContainer_'],",
    "[class*='_gridItemContent_'],",
    "[class*='_formHeader_'],",
    "[class*='_formFieldset_'],",
    "[class*='_formFieldContainer_'] {",
    '  width: 100% !important;',
    '  align-items: stretch !important;',
    '  justify-items: stretch !important;',
    '  margin-left: 0 !important;',
    '  margin-right: auto !important;',
    '  box-sizing: border-box !important;',
    '  overflow: visible !important;',
    '  text-align: left !important;',
    '}',
    "[class*='_formFieldContainer_'] {",
    '  max-width: calc(100% - 2px) !important;',
    '}',
    "[class*='_textBody_'],",
    "[class*='_textBody_'] p {",
    '  width: 100% !important;',
    '  margin-left: 0 !important;',
    '  margin-right: 0 !important;',
    '  text-align: left !important;',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  opacity: 0.9 !important;',
    '}',
    '@media screen and (max-width: 749px) {',
    '  :host {',
    '    --forms-padding-top: 0 !important;',
    '    --forms-padding-bottom: 0 !important;',
    '    --app-embed-padding-y: 0 !important;',
    '    --spacing-size-y: 0 !important;',
    '  }',
    "  [class*='_container_'] {",
    '    display: block !important;',
    '    align-content: start !important;',
    '    justify-content: flex-start !important;',
    '    place-content: start !important;',
    '  }',
    "  [data-sizing='form-wrapper'],",
    "  [class*='_inline_'],",
    "  [class*='_formContainer_'],",
    "  [class*='_gridItemContent_'] {",
    '    display: block !important;',
    '    min-height: 0 !important;',
    '    padding-top: 0 !important;',
    '    padding-bottom: 0 !important;',
    '  }',
    "  [class*='_imageLoading_'] {",
    '    display: none !important;',
    '  }',
    "  button[data-testid='btn-form-submit'] {",
    '    justify-content: space-between !important;',
    '    text-align: left !important;',
    '  }',
    '}'
  ].join('\n');

  function applyStyles() {
    document.querySelectorAll('.cl-footer .cl-footer__column--app shopify-forms-embed').forEach(function (embed) {
      if (!embed.shadowRoot) return;

      var existingStyle = embed.shadowRoot.getElementById(styleId);
      if (existingStyle) {
        if (existingStyle.textContent !== styles) {
          existingStyle.textContent = styles;
        }
        return;
      }

      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      embed.shadowRoot.appendChild(style);
    });
  }

  document.addEventListener('DOMContentLoaded', applyStyles);
  applyStyles();

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('shopify-forms-embed').then(applyStyles);
  }

  var attempts = 0;
  var retry = window.setInterval(function () {
    attempts += 1;
    applyStyles();

    if (attempts >= 40) {
      window.clearInterval(retry);
    }
  }, 250);

  new MutationObserver(applyStyles).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
